var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "bg-gray-light" }, [
    _c("div", { staticClass: "container text-center p-0" }, [
      _c("div", { staticClass: "notfound-box mt-3 mb-3" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("icon", {
                attrs: { name: "exclamation-triangle", scale: "5" }
              })
            ],
            1
          )
        ]),
        _vm._m(0),
        _vm._m(1),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "button",
              {
                staticClass: "go-home",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.redirect()
                  }
                }
              },
              [_vm._v(" ACCUEIL ")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col title-error" }, [_vm._v(" 404 ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col" }, [
        _vm._v(" La page que vous recherchez n'existe pas (ou plus). ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }